import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { RoleGuard } from "app/guards";
import { EstablecimientosProvider } from "./establecimientos-context";
import { EstablecimientosTable } from "./establecimientos-table";
import { EstablecimientoForm } from "./establecimiento-form";

export function EstablecimientosRoutes() {
  return (
    <RoleGuard roles={["empresa:establecimientos"]}>
      <EstablecimientosProvider>
        <Routes>
          <Route path="/" element={<Outlet />}>
            <Route index element={<EstablecimientosTable />} />

            <Route path="add" element={<EstablecimientoForm />} />

            <Route path=":establecimiento_id" element={<Outlet />}>
              <Route index element={<Navigate to="edit" replace />} />

              <Route path="edit" element={<EstablecimientoForm />} />
            </Route>

            <Route path="*" element="Establecimientos: Page Not Found" />
          </Route>
        </Routes>
      </EstablecimientosProvider>
    </RoleGuard>
  );
}
